module.exports = __webpack_public_path__ + "static/img/2_2_2_4.909f912f.jpg";